module.exports = __webpack_public_path__ + "static/media/cover-page.53f66671.jpg";